import { withDependencies } from '@wix/thunderbolt-ioc'
import type { INamedSignalsHandlers, SignalChangeCallback } from './types'

export const NamedSignalsHandlers = withDependencies([], (): INamedSignalsHandlers => {
	// listeners for changes to the local (client) signals
	const localChangesListeners = new Set<SignalChangeCallback>()
	// listeners for changes to the remote (worker) signals
	const remoteChangesListeners = new Set<SignalChangeCallback>()

	return {
		// API for the main-thread
		updatePlatform: async (name, value) => {
			localChangesListeners.forEach((cb) => cb(name, value))
		},
		onPlatformChange: async (cb) => {
			remoteChangesListeners.add(cb)
		},
		// API for the platform
		getSdkHandlers: () => ({
			namedSignals: {
				update: (name: string, value: any) => {
					remoteChangesListeners.forEach((cb) => cb(name, value))
				},
				subscribe: (cb: SignalChangeCallback) => {
					localChangesListeners.add(cb)
					return () => localChangesListeners.delete(cb)
				},
			},
		}),
	}
})
